//引入时间转化过滤器
import toTime from './toTime'
export default {
    toTime
}


// WEBPACK FOOTER //
// ./src/filter/index.js